import { render, staticRenderFns } from "./ArchyvDokladuList.vue?vue&type=template&id=66921402&"
import script from "./ArchyvDokladuList.vue?vue&type=script&lang=ts&"
export * from "./ArchyvDokladuList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports